import {BaseEntity} from "../common/baseEntity";
import {Company} from "./company";
import {Location} from "../management/locationManagement/location";
import {Order} from "../orders/order";
import {LocationType} from "../management/locationManagement/locationType";
import {OrderItem} from "../orders/orderItem";
import { OrderLocation } from "../management/order/orderLocation";
import {StripePaymentData} from "./stripe-payment-data";
/**
 * Created by alex.y on 9/7/2017.
 */
export class Customer extends BaseEntity<number> {
    public FirstName: string;
    public LastName: string;
    public Phone: string;
    public Email: string = "";
    public Company: Company = new Company();
    public IsSeller: boolean;
    public Flag: number;
    public LocationId: number;
    public Location: OrderLocation = new OrderLocation();
    public OrderIDs: Array<number> = [];
    public Orders: Array<Order> = new Array<Order>();
    public StripePaymentData: StripePaymentData = new StripePaymentData();
    public OriginalId: number;

    public constructor() {
        super();
    }
}



// WEBPACK FOOTER //
// ./app/objects/customers/customer.ts